export const HomeVar = {
  last_updated: "Last Updated:",
  time: "12:15:00 am",
  line_efficiency: "Line Efficiency",
  production_counter: "Production Counter",
  efficiency_chart: "Efficiency Chart",
};
export const IntegrationsVar = { heading: "Integrations" };
export const HomeAlertsVar = { alerts: "Alerts", view_all: "View All" };
export const PlantsettingsVar = { heading: "Plant Settings" };
export const PlantsettingsRoleVar = { heading: "Role" };
export const DowntimeLogVar = { heading: "Downtime Log" };
export const APIParamVar = { heading: "REST API Accepted Parameters" };
export const APIRestPointsVar = { heading: "REST API Endpoints" };
export const LineOperatorCompVar = { line_operator: "Line Operator" };
export const auth = {
  remember_me: "Remember me",
  heading: "Login",
  forgot_pass: "Forgot Password?",
  no_acc: "Don't Have An Account?",
  signup_text: "Sign Up",
};

export const RoleModalVar = {
  role_name: "Role Name",
  capabilities: "CAPABILITIES",
  domain: "Domain",
  demo: "Demo",
  submit: "Submit",
  email_address: "EMAIL ADDRESS",
  password: "PASSWORD",
  define_role: "DEFINE ROLE",
  lines: "LINES",
  text: "The system will take your email address only for the creation of your ID. No other personal information will be captured by the system.",
};
export const PlantSettingsAlertsVar = {
  heading: "Alerts",
  add_alert: "Add Alert",
  type: "Type",
  lines: "Lines",
  status: "statuss",
  sms_alert: "SMS Alert",
  select_time: "Select Time",
  from_value: "From Value",
  to_value: "To Value",
  phone_numbers: "Phone Numbers (comma seperated)",
  email_address: "Email address (comma seperated)",
  subject: "Subject (subject will not be shared if not entered)",
  content: "Content (content will not be shared if not entered)",
  email_cc: "CC: Email address (comma seperated)",
  email_bcc: "BCC: Email address (comma seperated)",
};
export const PlantSiteChampionVar = { heading: "Site Champion" };
export const ProgressCompVar = { percent_sign: "%" };
export const SidebarVar = {
  user_name: "Erick Mann",
  user_email: "erick@company.com",
};
export const RoleTableVar = { roles: "Roles" };
export const UserButtonVar = { heading: "Line Operator" };
export const LineInformationVar = {
  line: "LINE NAME",
  target_oee: "TARGET OEE",
  defaultMachine: "DEFAULT MACHINE NAME",
  timeZone: "TIME ZONE",
  machineName:'MACHINE NAME',
  hallNAme: "HALL NAME",
  importReason: "IMPORT REASONS",
};

export const LineSettingsShiftVar = {
  heading: "Shifts",
  add_shift: "Add Shift",
  name: "NAME",
  select_time: "SHIFT TIMINGS",
  product: "PRODUCT",
};

export const LineSettingsProductVar = {
  heading: "Products",
  add_product: "Add Product",
  name: "NAME",
  sku: "SKU",
  recipe: "RECIPE"
};

export const DowntimeVar = { heading: "Downtime" };

export const PlannedDowntimeVar = {
  heading1: "Planned Downtime",
  heading2: "Planned Stoppage",
  add_downtime: "Add Planned Downtime",
  add_stoppage: "Add Planned Stoppage",
  reason: "REASON",
  stoppage_time: "STOPPAGE TIME(MINUTES)",
  downtime: "DOWNTIME",
};